// @flow
import { useCallback, useState } from 'react';
import { useQuery } from 'react-query';
import type { QueryKey, UseQueryResult, QueryFunction, UseQueryOptions } from 'react-query';

type FetchCallback = ()=> void;

export default function useLazyQuery<
    TQueryFnData = any,
    TError = any,
    TData = TQueryFnData,
    >
(
	queryKey: QueryKey,
	queryFn: QueryFunction<TQueryFnData>,
	options?: UseQueryOptions<TQueryFnData, TError, TData>,
): [FetchCallback, UseQueryResult<TData, TError>] {
	const [enabled, setEnabled] = useState(false);
	// $FlowFixMe
	const query: UseQueryResult<TData, TError> = useQuery<TData, TError>(
		queryKey,
		queryFn,
		{ ...options, enabled },
	);
	return [
		useCallback<FetchCallback>(() => setEnabled(true), []),
		query,
	];
}